import { withStyles } from "@material-ui/core";
import { getZoneValue } from "../../../utils";
import React from "react";
import Details from "./Details";
import DetailsList from "./DetailsList";
import appConstants from "../../../../../../../appConstants";
import { AccHoursRenderer } from "../../Grid/cellRenderer";
const styles = (theme) => ({
  container: {
    display: "flex",
    border: `1px solid ${theme.AppBGColor}`,
    flexDirection: "row",
    flexGrow: 3,
    padding: "10 12 10 12",
    justifyContent: "space-between",
    flexWrap: "wrap"
  },
  innerContainer: {
    display: "flex",
    flexDirection: "column",
  },
});
const KPIContainer = ({
  classes,
  stopsPerHour,
  lunchIn,
  lunchOut,
  fuelIn,
  fuelOut,
  dispatchZone,
  dailyAccruedHours,
  enableDriverZone,
  weeklyAccruedHours,
  weeklyAllowedHOS,
  enableWeeklyAccruedHours,
}) => {
  const getFeatureBasedManHourValueRenderer = () => {
    const dailyAccruedHourValueRenderer = (
      <AccHoursRenderer
        allowedHOS={appConstants.DAILY_ALLOWED_HOS}
        accruedHours={dailyAccruedHours}
      />
    );
    return enableWeeklyAccruedHours
      ? [
          dailyAccruedHourValueRenderer,
          <AccHoursRenderer
            allowedHOS={weeklyAllowedHOS}
            accruedHours={weeklyAccruedHours}
          />,
        ]
      : [dailyAccruedHourValueRenderer];
  };

  const getFeatureBasedManHourLabels = () => {
    const accruedHourLabel = "Acc Hours Daily";
    return enableWeeklyAccruedHours
      ? [accruedHourLabel, "Weekly"]
      : [accruedHourLabel];
  };

  return (
    <div className={classes.container}>
      <div className={classes.innerContainer}>
        <Details label="Stops per Hr" value={stopsPerHour ?? "NA"} />
        {enableDriverZone > 0 ? (
          <Details
            label="Zones"
            value={getZoneValue({ data: { dispatchZone } })}
          />
        ) : (
          <DetailsList
            labels={getFeatureBasedManHourLabels()}
            values={getFeatureBasedManHourValueRenderer()}
          />
        )}
      </div>
      <div className={classes.innerContainer}>
        <DetailsList
          labels={["Lunch In", "Out"]}
          values={[lunchIn, lunchOut]}
        />
        {enableDriverZone > 0 && (
          <DetailsList
            labels={getFeatureBasedManHourLabels()}
            values={getFeatureBasedManHourValueRenderer()}
          />
        )}
      </div>
      <div className={classes.innerContainer}>
        <DetailsList labels={["Fuel In", "Out"]} values={[fuelIn, fuelOut]} />
      </div>
    </div>
  );
};
export default withStyles(styles)(KPIContainer);
